<script setup lang="ts">
import type {ConversationMessage} from "@/conversation/interfaces";
import {computed} from "vue";
import ConversationDaySeparator from "@/conversation/components/ConversationDaySeparator.vue";
import BaseEmpty from "@/core/components/base/BaseEmpty.vue";
import ConversationMessagePreview from "@/conversation/components/ConversationMessagePreview.vue";

const props = defineProps<{
    messages: ConversationMessage[];
}>();

const messagesByDay = computed(() => {
    return props.messages.reduce((groups, message) => {
        const messageDate = new Date(message.created_at);

        const key = messageDate.toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        const last = groups.at(-1);
        if (last?.dateKey === key) {
            last.messages.push(message);
        } else {
            groups.push({dateKey: key, messages: [message]});
        }
        return groups;
    }, [] as { dateKey: string; messages: ConversationMessage[] }[]);
});
</script>

<template>
  <div v-if="messages.length === 0">
    <BaseEmpty
      title="Aucun message"
      description="Cette conversation ne contient pas encore de messages."
    />
  </div>

  <div
    v-else
    class="flex flex-col px-4 py-3"
  >
    <template v-for="group in messagesByDay" :key="group.dateKey">
      <ConversationDaySeparator :date="group.dateKey" />

      <ConversationMessagePreview v-for="message in group.messages" :key="message.id" :message="message" />
    </template>
  </div>
</template>
